<script lang="ts">
  import CTooltip from '$shared/atoms/CTooltip/CTooltip.svelte';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import { onMount } from 'svelte';

  interface Props {
    value?: DataListValue;
  }

  let { value = {} }: Props = $props();

  let content = $state('');

  onMount(() => {
    if (value.showTooltip) {
      content = `<b>Provided info doesn't match verified result</b> <br />
      The information we retrieved from the primary source is different than the information you provided for this field.`;
    }
  });
</script>

{#if value.showTooltip}
  <CTooltip label={content}><Icon value={value.icon?.toString()} fontSize={'18px'} /></CTooltip>
{:else}
  <Icon value={value.icon?.toString()} fontSize={'18px'} />
{/if}
